"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var app_1 = require("../configs/app");

var UtilsRow = __importStar(require("./row"));

function getLabels(items) {
  var result = [];
  lodash_1.default.forEach(items, function (item, k) {
    var rows = item.rows;

    if (lodash_1.default.isArray(rows)) {
      result = lodash_1.default.concat(result, UtilsRow.getRowsLabels(rows));
    }
  });
  return lodash_1.default.uniqWith(result, lodash_1.default.isEqual);
}

exports.getLabels = getLabels;

function getLabelsForSort(items) {
  var result = [];
  lodash_1.default.forEach(items, function (item, k) {
    var rows = item.rows;

    if (lodash_1.default.isArray(rows)) {
      result = lodash_1.default.concat(result, UtilsRow.getRowsLabelsForSort(rows));
    }
  });
  return lodash_1.default.uniqWith(result, lodash_1.default.isEqual);
}

exports.getLabelsForSort = getLabelsForSort;

function getColumns(items, label, currentColumn) {
  var isDiff = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var result = [];

  if (label === null) {
    return result;
  }

  lodash_1.default.forEach(items, function (item, k) {
    var rows = item.rows;

    if (lodash_1.default.isArray(rows)) {
      result = lodash_1.default.concat(result, UtilsRow.getRowsColumnsWithSameLabel(rows, label, currentColumn, isDiff));
    }
  });
  return lodash_1.default.uniqWith(result, lodash_1.default.isEqual);
}

exports.getColumns = getColumns;

function getFilterData(item) {
  var rows = getRows(item);
  return rows.reduce(function (acc, cur) {
    return lodash_1.default.concat(acc, UtilsRow.getFilterData(cur));
  }, []);
}

exports.getFilterData = getFilterData;

function getRows(item) {
  return lodash_1.default.get(item, 'rows', []);
}

exports.getRows = getRows;

function getRelatedItemsRowLabels(items, relationLabel) {
  var itemDataList = getRelatedItems(items, relationLabel);
  var labels = itemDataList.reduce(function (accu, itemData) {
    var rows = itemData.rows;
    var rowLabels = UtilsRow.getRowsLabels(rows);
    return lodash_1.default.concat(accu, rowLabels);
  }, []);
  return lodash_1.default.union(labels);
}

exports.getRelatedItemsRowLabels = getRelatedItemsRowLabels;

function getRelatedItems(items, relationLabel) {
  var relatedItemIdsWithSameRowLabel = items.reduce(function (accu, item) {
    var rows = item.rows;
    var ids = UtilsRow.getRelatedItemIds(rows, relationLabel);
    return lodash_1.default.concat(accu, ids);
  }, []);
  var result = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = relatedItemIdsWithSameRowLabel[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var itemId = _step.value;
      var itemData = lodash_1.default.find(items, {
        id: itemId
      });

      if (itemData) {
        result.push(itemData);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

exports.getRelatedItems = getRelatedItems;

function orderItems(items, sortId, isReversed) {
  var isDefaultReversed = app_1.DEFAULT_REVERSE_DATASET_LABELS.indexOf(sortId) !== -1;

  if (isReversed && !isDefaultReversed || !isReversed && isDefaultReversed) {
    return lodash_1.default.reverse(items);
  } else {
    return items;
  }
}

exports.orderItems = orderItems;